import React from 'react';
import styles from './styles';
import { Check, EmojiEvents } from '@mui/icons-material';

interface Props {
  emoji?: string;
  title: string;
  benefits?: string[];
}

const SimpleCover: React.FC<Props> = ({
  emoji,
  title,
  benefits,
}) => {
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        {emoji ? <span style={styles.emoji}>{emoji}</span> : <EmojiEvents style={styles.emoji} />}
        <h1 style={styles.title}>¡Felicidades!</h1>
        <p style={styles.subtitle}>Completaste: {title}</p>
      </div>

      <ul style={styles.achivementsContainer}>
        {benefits?.map((item: string, index: number) => (
          <li key={index} style={styles.achivement}>
            <span style={styles.checkIcon}>
              <Check />
            </span>
            <p>{item}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SimpleCover;
